import React, { useEffect, useRef } from "react";
import { useSiteContext } from "../../../context/SiteContext";

const FORM_ID = "H4aZuP69nawMIZ0RcrM7";

const Support = () => {
  const { user } = useSiteContext();
  const containerRef = useRef(null);
  const cleanupRef = useRef(null);

  // GoHighLevel's form_embed.js reads prefill params from the PARENT page's
  // URL (window.location.search), not from the iframe src. We temporarily
  // inject the user's name/email into the page URL so the embed script picks
  // them up, then restore the original URL.
  useEffect(() => {
    if (!user) return;

    const name = user.name || user.fullName || "";
    const email = user.email || "";
    if (!name && !email) return;

    const originalSearch = window.location.search;
    const params = new URLSearchParams(window.location.search);

    if (name) {
      params.set("full_name", name);
      params.set("name", name);
      const parts = name.trim().split(/\s+/);
      params.set("first_name", parts[0] || "");
      params.set("last_name", parts.slice(1).join(" ") || "");
    }
    if (email) params.set("email", email);

    const newUrl =
      window.location.pathname + "?" + params.toString() + window.location.hash;
    window.history.replaceState(null, "", newUrl);

    // Restore original URL after the embed script has had time to read params.
    cleanupRef.current = setTimeout(() => {
      const restoreUrl =
        window.location.pathname +
        (originalSearch || "") +
        window.location.hash;
      window.history.replaceState(null, "", restoreUrl);
    }, 3000);

    return () => {
      if (cleanupRef.current) clearTimeout(cleanupRef.current);
      // Restore URL on unmount in case timeout hasn't fired yet.
      const restoreUrl =
        window.location.pathname +
        (originalSearch || "") +
        window.location.hash;
      window.history.replaceState(null, "", restoreUrl);
    };
  }, [user]);

  useEffect(() => {
    // Inject the LeadConnector form embed script once.
    const existing = document.querySelector(
      'script[src="https://link.r-link.com/js/form_embed.js"]'
    );
    if (!existing) {
      const s = document.createElement("script");
      s.src = "https://link.r-link.com/js/form_embed.js";
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <div className="w-full">
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-white font-sans leading-tight">
          Help &amp; Support
        </h1>
        <p className="text-gray-400 text-sm mt-1">
          Get help and access support resources
        </p>
      </div>

      <div
        ref={containerRef}
        className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-2 md:p-4"
      >
        <iframe
          key={user?.email || "anon"}
          src={`https://link.r-link.com/widget/form/${FORM_ID}`}
          style={{
            width: "100%",
            height: "720px",
            border: "none",
            borderRadius: "10px",
          }}
          id={`inline-${FORM_ID}`}
          data-layout="{'id':'INLINE'}"
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name="Support Form in R-Link Platform"
          data-height="669"
          data-layout-iframe-id={`inline-${FORM_ID}`}
          data-form-id={FORM_ID}
          title="Support Form in R-Link Platform"
        />
      </div>
    </div>
  );
};

export default Support;
